"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingOverlay = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = require("../");

var _framerMotion = require("framer-motion");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var LoadingOverlay = function LoadingOverlay() {
  return /*#__PURE__*/_react["default"].createElement(_.View, {
    as: _framerMotion.motion.div,
    extend: loadingCSS
  }, /*#__PURE__*/_react["default"].createElement(_.Spinner, null));
};

exports.LoadingOverlay = LoadingOverlay;

var loadingCSS = function loadingCSS() {
  return {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(255,255,255,0.8)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  };
};